export enum ActionMode {
  SAVE = 'SAVE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  VIEW = 'VIEW',
  ADD = 'ADD',
  BLACKLIST = 'BLACKLIST',
  SUSPEND = 'SUSPEND',
  REVERSE_BLACKLIST = 'REVERSE_BLACKLIST',
  REVERSE_SUSPEND = 'REVERSE_SUSPEND',
  REVERSE_SUSPEND_BLACKLIST = 'REVERSE_SUSPEND_BLACKLIST',
  APPROVE = 'APPROVE',
  RETURN = 'RETURN',
  REJECT = 'REJECT'
}
